/* eslint-disable react-hooks/exhaustive-deps */
import { Tag } from "primereact/tag";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { ConfigurtionPanelProperties } from "types/ConfigurationPanel/ConfigurationPanel.interface";
import { useAppSelector } from "hooks";
// import { nsoFlowFetchNsoRequestData } from "../../redux/nsoFlow/nsoFlowSlice";
import CommonLoader from "components/CommonLoader";
import { accessoriesSorter } from "utils/commonFunctions";

export default function ConfigurationPanel({ id }: ConfigurtionPanelProperties) {
  const location = useLocation();
  const { home } = useAppSelector((state) => state.home);
  const { nsoFlow, loading } = useAppSelector((state) => state.nsoFlow);
  const pathSegment = location.pathname.split("/").filter(Boolean);

  console.log("id", id);
  // const dispatch = useAppDispatch();

  const [originalConfigSorted, setOriginalConfigSorted] = useState<any>({});

  // useEffect(() => {
  //   if (id) {
  //     dispatch(nsoFlowFetchNsoRequestData({ id, stepId: 1 }));
  //     dispatch(nsoFlowFetchNsoRequestData({ id, stepId: 2 }));
  //   }
  // }, [dispatch, id]);

  const requestedConfig = nsoFlow?.data[0]?.data?.request_json;
  const originalConfig = nsoFlow?.data[1]?.data?.response_json;
  console.log(requestedConfig, originalConfig);

  useEffect(() => {
    const sortConfigurations = async () => {
      if (originalConfig) {
        try {
          const sortedData = await accessoriesSorter(originalConfig?.accessoryDetail);
          setOriginalConfigSorted(sortedData);
        } catch (error) {
          console.error("Error sorting original config: ", error);
        }
      }
    };
    sortConfigurations();
  }, [originalConfig, requestedConfig, pathSegment[0]]);

  // const originalConfigPPOOptions = originalConfig?.accessoryDetail?.filter(
  //   (item: { accessoryType: string }) => item.accessoryType === "P",
  // );

  if (loading) {
    return <CommonLoader active={loading} />;
  }

  return (
    <div className="pt-2">
      <div className="flex flex-col py-2 px-2 bg-gray-100 rounded-lg">
        <div className="grid grid-cols-3 grid-rows-2 gap-2 mx-8 rounded-t-lg px-2 py-2 items-center App">
          <div className="flex flex-row items-left">
            <span className="text-base font-bold">Sold Order No. :&nbsp;</span>
            <span className="text-base h-6 w-auto">{requestedConfig?.soldOrderNo}</span>
          </div>
          <div className="flex flex-row justify-center">
            <span className="text-base font-bold">URN : &nbsp;</span>
            <span className="text-base h-6 w-auto">{requestedConfig?.urn}</span>
          </div>
          <div className="flex flex-row justify-end">
            <span className="text-base font-bold">Date : &nbsp;</span>
            <span className="text-base h-6 w-auto">{home?.date}</span>
          </div>
          <div className="flex flex-row items-left items-center">
            <span className="text-base font-bold">Dealer Code : &nbsp;</span>
            <span className="text-base h-6 w-auto pt-0.5">{requestedConfig?.dealerCode}</span>
          </div>
          <div className="flex flex-row justify-center items-center">
            <span className="text-base font-bold">Model Year : &nbsp;</span>
            <span className="text-base h-6 w-auto pt-0.5">{requestedConfig?.modelYear}</span>
          </div>
          <div className="flex flex-row justify-end items-center">
            <span className="text-base font-bold">Execution Status : &nbsp;</span>
            <div className="items-center">
              <Tag severity="info" className="bg-blue-700 text-base" value={home?.status} />
            </div>
          </div>
        </div>
      </div>
      <div className="pt-2"></div>
      <div className="flex flex-row gap-4 mx-0 border-t-8 border-b-8 border-white bg-gray-100 App">
        <div className="w-1/2 h-auto py-2 px-2 mx-8">
          <h3 className="text-sm font-bold py-1">
            <Tag rounded className="bg-gray-500 h-6 w-fill text-sm">
              Original Configuration
            </Tag>
          </h3>
          <div className="flex flex-col gap-1 pt-1">
            <div className="flex flex-row justify-between">
              <div className="flex flex-row">
                <span className="text-base font-bold">Model : &nbsp;</span>
                <span className="text-base h-6 w-auto">{originalConfig?.modelCode}</span>
              </div>
              <div className="flex flex-row">
                <span className="text-base font-bold">Exterior Color : &nbsp;</span>
                <span className="text-base h-6 w-auto">{originalConfig?.exteriorColor}</span>
              </div>
              <div className="flex flex-row pr-4">
                <span className="text-base font-bold">Interior Color : &nbsp;</span>
                <span className="text-base h-6 w-auto">{originalConfig?.interiorColor}</span>
              </div>
            </div>
            <div className="grid grid-cols-2">
              <div>
                <span className="text-base font-bold">Factory Accessories: &nbsp;</span>
                <span className="text-base h-6 w-auto">
                  {originalConfigSorted?.factoryAccessory?.map((item: any) => item).join(", ") || ""}{" "}
                </span>
              </div>
              <div>
                <span className="text-base font-bold">PPO Accessories: &nbsp;</span>
                <span className="text-base h-6 w-auto">
                  {originalConfigSorted?.ppoAccessory?.map((item: any) => item).join(", ") || ""}{" "}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-1/2 h-auto py-2 px-2 border-white border-l-8">
          <h3 className="text-sm font-bold py-1">
            <Tag rounded className="bg-gray-500 h-6 w-fill text-sm">
              Requested Configuration
            </Tag>
          </h3>
          <div className="flex flex-col gap-1 pt-1">
            <div className="flex flex-row justify-between">
              <div className="flex flex-row">
                <span className="text-base font-bold">Model : &nbsp;</span>
                <span className="text-base h-6 w-auto">{requestedConfig?.modelNo}</span>
              </div>
              <div className="flex flex-row">
                <span className="text-base font-bold">Exterior Color : &nbsp;</span>
                <span className="text-base h-6 w-auto">{requestedConfig?.exteriorColor}</span>
              </div>
              <div className="flex flex-row pr-6">
                <span className="text-base font-bold">Interior Color : &nbsp;</span>
                <span className="text-base h-6 w-auto">{requestedConfig?.interiorColor}</span>
              </div>
            </div>
            <div className="grid grid-cols-2">
              <div>
                <span className="text-base font-bold">Factory Accessories: &nbsp;</span>
                <span className="text-base h-6 w-auto">{requestedConfig?.factoryOptions?.split(",").join(", ")}</span>
              </div>
              <div>
                <span className="text-base font-bold">PPO Accessories: &nbsp;</span>
                <span className="text-base h-6 w-auto">{requestedConfig?.ppoOptions?.split(",").join(", ")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ConfigurationPanel.propTypes = {
  id: PropTypes.string,
};
